export const coachAssignmentSiteCoreKeys = {
  coachAssignment:
    "ProgramsAndCandidates.CreateProgramComponent.CoachAssignment",
  coachAssignmentToBeAssignedDate: "CoachAssignment.ToBeAssignedDate",
  coachAssignmentAddFunction: "CoachAssignment.AddFunction",
  coachAssignmentDeleteConfirm:
    "CoachAssignment.AreYouSureYouWantToDeleteThisAssignment",
  coachAssignmentEntryDeleted: "CoachAssignment.EntryDeleted",
  coachAssignmentFunctionDropDownLabel: "CoachAssignment.FunctionDropDownLabel",
  coachAssignmentActionTableHeading: "CoachAssignment.ActionTableHeading",
  coachAssignmentAssignedDateTableHeading:
    "CoachAssignment.AssignedDateTableHeading",
  coachAssignmentCoachTableHeading: "CoachAssignment.CoachTableHeading",
  coachAssignmentAssignCoachButton: "CoachAssignment.AssignCoachButton",
  coachAssignmentEditButton: "CoachAssignment.EditButton",
  coachAssignmentFunctionTableHeading: "CoachAssignment.FunctionTableHeading",
  coachNoAssignmentsToView: "CoachAssignment.NoAssignmentsToView",
  coachAlreadyAssigned: "CoachAssignment.CoachAlreadyAssigned",
};

export const coachAssignmentModelSiteCorePopup = {
  assignCoach:
    "ProgramsAndCandidates.CreateProgramComponent.AssignCoachModelPopup",
  assignCoachEditTitle: "AssignCoachModelPopup.EditAssignCoachTitle",
  assignCoachFunc: "AssignCoachModelPopup.Function",
  assignCoachCoach: "AssignCoachModelPopup.Coach",
  assignCoachConfirmAssign: "AssignCoachModelPopup.AreYouSureToAssignThisCoach",
  assignCoachConfirmChange: "AssignCoachModelPopup.AreYouSureToChangeThisCoach",
  assignCoachConfirmDiscardChanges:
    "AssignCoachModelPopup.AreYouSureYouWantToDiscardTheChanges",
  assignCoachConfirmDiscardSelection:
    "AssignCoachModelPopup.AreYouSureYouWantToDiscardTheSelection",
};
